import { IRestModel } from '@shared/interface/IRestModel';
import { RestModelUtility } from '@shared/utility/RestModel.Utility';
import { BaseModel } from '@shared/base/Base.Model';

export class ColumnFilterOptionModel extends BaseModel implements IRestModel {
    public columnName: string = null;
    public filter: string = null;
    public filterAll: boolean = null;
    public readonly isIRestModel = true;

    public constructor() {
        super();
    }

    public loadFromRestApiModel(restModel: any): void {
        RestModelUtility.loadProperties(restModel, this, 'EM-ColumnFilterOptionModel');
    }

    public toRestApiModel() {
        throw new Error('Method not implemented.');
    }
}
